module.exports = __webpack_public_path__ + "img/9.8f07afd7.jpg";